module.exports = __webpack_public_path__ + "img/span-city-title.b6bac184.png";